import cn from 'classnames';
import { twMerge } from 'tailwind-merge';

export const classNames = (...cls: cn.ArgumentArray) => {
  return twMerge(cn(cls));
};
